export const SET_AUTH = 'setUser';
export const SET_USER_AVATAR = 'setUserAvatar';

const state = {
  user: {},
  userAvatar: require('../../../assets/image/profile-placeholder.png'),
};

const getters = {
  userAvatar(state) {
    return state.userAvatar;
  },
};

const actions = {};

const mutations = {
  [SET_USER_AVATAR](state, payload) {
    state.userAvatar = payload;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
